import localforage from "localforage";

localforage.config({
  driver: localforage.INDEXEDDB,
  name: "ims-mobile-app",
  storeName: "app",
});
